import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesLandingRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-landing',
	// Supporting optional /default for legacy backwards compatability
	path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
	exact: true,
};
